<div ngbDropdown placement=left-top class="c-action-menu" (openChange)="openChange.emit($event)" *ngIf="showButton">
    <button class="btn c-action-menu__toggle" ngbDropdownToggle><i class="icon-more-vertical"></i></button>
    <div ngbDropdownMenu class="c-action-menu__dropdown">
        <div>
            <ng-content></ng-content>
        </div>
    </div>
</div>
